import { Briefcase } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { ProjectsPage } from './pages/ProjectsPage'

/**
 * Formulation Projects (Sprint 10).
 *
 * Customer-driven container layered on top of Sprint 08/08b Formulations.
 * One project per customer R&D ask; owns N formulations as the team
 * iterates. Status state-machine mirrors Formulations exactly (D-2):
 * draft / testing / approved / rejected. Sample-order linkage via
 * auto-detect (`SMPL*` / `SAMP*` default_code prefix on Odoo product)
 * + manual confirm (D-3).
 *
 * Middleware endpoints land under `/api/projects/*` — see
 * `docs/active/sprint-10-formulations-projects.md`.
 *
 * RBAC: visibility gated to admin + sales + regulatory + operations.
 * Sales owns the customer ask; admin supervises; regulatory + operations
 * read for context but do not edit (writes guarded server-side at
 * `admin + sales` per the route handler `require_roles` calls).
 */
export default defineModule({
  id: 'projects',
  name: 'Projects',
  shortName: 'Projects',
  icon: Briefcase,
  // Sprint 13a (2026-04-26): moved from `ops` to `formulations` —
  // Projects is the customer-driven container layered on top of
  // Formulations, so it sits with its host module in the new
  // section model.
  navSection: 'formulations',
  // Below Formulations (10): the customer-driven workflow reads
  // after the production-formulation register.
  navOrder: 20,
  urlNamespace: '/projects',
  routes: [{ path: '/', element: ProjectsPage, label: 'Projects' }],
  permissions: ['admin', 'sales', 'regulatory', 'operations', 'operations_logistics', 'purchasing'],
  densityDefault: 'comfortable',
  filterRailDefault: 'collapsed',
  mobileStrategy: 'desktop-only',

  // 'g p' is bound by procurement, 'g r' by formulations. 'g j'
  // (J for "Jobs" / "active customer Jobs") is the cleanest open
  // mnemonic and adjacent to 'g k' (free) for future expansion.
  keyboardShortcut: 'g j',

  commandPaletteEntries: [
    {
      label: 'Go to Projects',
      keywords: [
        'project',
        'projects',
        'r&d',
        'rd',
        'jobs',
        'customer',
        'wip',
        'in progress',
        'ask',
      ],
      path: '/',
      group: 'modules',
      shortcut: 'g j',
    },
  ],
})
